'use client';

import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { userManager } from '../services/authService';
import { appInsightsReactPlugin, loadAppInsights } from '../utils/applicationInsights';
import AuthProvider from './authProvider';
import { GoogleReCaptchaProvider } from './googleRecaptchaProvider';
import { QueryProvider } from './queryProvider';
import TagManager from 'react-gtm-module';
import { clarity } from 'react-microsoft-clarity';
import { useEffect } from 'react';

const gtmId = process.env.NEXT_PUBLIC_GTM_TOKEN || '';
const clarityId = process.env.NEXT_PUBLIC_CLARITY_TOKEN || '';

const tagManagerArgs = {
  gtmId,
};

export function Providers({ children }: { children: React.ReactNode }) {

  useEffect(() => {
    const isProduction =
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'Production' ||
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'Production-EU';

    const hasInstrumentationKey = process.env.NEXT_PUBLIC_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY !== '';

    // --- Inicialização App Insights ---
    if (isProduction && hasInstrumentationKey) {
      loadAppInsights();
    }

    if (!isProduction && hasInstrumentationKey) {
      console.log(`update v 15/12/25`);
    }

    // --- Inicialização GTM e Clarity ---
    if (isProduction) {
      TagManager.initialize(tagManagerArgs);
      clarity.init(clarityId);
    }
  }, []);

  return (
    <AppInsightsContext.Provider value={appInsightsReactPlugin}>
      <AuthProvider userManager={userManager}>
        <QueryProvider>
          <GoogleReCaptchaProvider>{children}</GoogleReCaptchaProvider>
        </QueryProvider>
      </AuthProvider>
    </AppInsightsContext.Provider>
  );
}